<template>
    <div class="card-body">
        <app-vpn-support-modal></app-vpn-support-modal>

        <div class="segment">

            <button class="btn btn-primary btn-extra-round"
                    slot="activator"
                    @click="register">
                {{$t('message.generics.message.register')}}
            </button>
            <tr>
                <td width="70px">
                    {{$t('message.spots.message.activate')}}
                </td>
                <td width="260px">
                    {{$t('message.spots.message.vpn')}}
                </td>
                <td width="60px">
                </td>
            </tr>

            <tr v-for="item in connectionSupportList" :key="item.id">
                <td width="70px">

                    <toggle-button switch-color="#FFFFFF"
                                   :width="40"
                                   :height="20"
                                   :color="colors"
                                   :sync="true"
                                   :value="item.active"
                                   @change="(evt) => updateConnectionSuport(evt.value, item)"></toggle-button>


                </td>
                <td width="260px">
                    {{item.name}}
                </td>
                <td width="60px">
                    <v-icon size="20" slot="activator" v-tooltip="$t('message.generics.message.edit')" @click="edit(item)">mdi-settings</v-icon>
                    <v-icon size="20" slot="activator" v-tooltip="$t('message.generics.message.remove')" @click="remove(item)">mdi-delete</v-icon>
                </td>



            </tr>

            <app-confirmation-modal :value="!!pendingRemoveItem"
                                    confirm-label="Remover"
                                    @confirm="confirmRemove"
                                    @cancel="pendingRemoveItem = null">
            <span slot="heading">
                {{$t('message.generics.message.remove')}}
            </span>
                <span>
                {{$t('message.generics.message.removeConfirmation')}}
            </span>
            </app-confirmation-modal>

        </div>
    </div>

</template>

<script>
    import ToggleButton from 'vue-js-toggle-button/src/Button'
    import AppVpnSupportModal from '../vpn-support-modal/VpnSupportModal'
    import EventBus from '@packages/event-bus'
    import AppConfirmationModal from '@components/ConfirmationModal'
    import palette from "@packages/colors";

    export default {
        components: {
            ToggleButton,
            AppVpnSupportModal,
            AppConfirmationModal
        },

        data() {
            return {
                connectionSupportList: [],
                pendingRemoveItem : null,
                connectionSupportActive:false,
                headers: [
                    {text: this.$t('message.generics.message.name'), value: 'nome'}
                ],
                colors: {
                    checked: palette.primary,
                    unchecked: '#E3E3E3',
                    disabled: '#CCCCCC'
                }
            }
        },

        props: {
            config: {
                type: Object
            }
        },

        methods: {
            register(){
                EventBus.$emit('CREATE_VPN_SUPPORT')
            },
            async loadConnectionsSupport() {
                this.connectionSupportList =  await this.$api.connectionsupport.list()
                if (!this.config.isSupportActive){
                    return;
                }
                this.connectionSupportList.forEach((item)=>{
                    if (item.id == this.config.connectionSupportId){
                        item.active = true
                    }
                })
            },

            async updateConnectionSuport(active, item){
                let config = {}
                config.connectionSupportId = item.id
                config.isSupportActive = active
                const res = await this.$api.devices.updateConnectionSupport(this.config.deviceId, config)
                this.config.connectionSupportId = item.id
                this.config.isSupportActive = active
                this.loadConnectionsSupport()
                EventBus.$emit('show-message', {
                    type: 'SUCCESS',
                    message: res.message,
                    timeout: 2000
                })
                EventBus.$emit('LOAD_DEVICES')
            },
            async confirmRemove() {
                await this.$api.connectionsupport.remove({id: this.pendingRemoveItem.id})
                this.loadConnectionsSupport()
                this.pendingRemoveItem = null
            },

            remove(item) {
                this.pendingRemoveItem = item
            },
            edit(item) {
                EventBus.$emit('EDIT_VPN_SUPPORT', item)
            }
        },
        mounted() {
            EventBus.$on('LOAD_VPN_SUPPORT', this.loadConnectionsSupport)
            this.loadConnectionsSupport()
        },
        beforeDestroy() {
            EventBus.$off('LOAD_VPN_SUPPORT', this.loadConnectionsSupport)
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@variables";

    .card-body {
        padding: 0px 50px 10px;

        .segment {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;


        }

        .box .box-wrapper{
            border-radius: 30px !important;
        }

        .buttons{
            width: 340px;
            border: none !important;
        }

        .v-btn-toggle {
            box-shadow: unset;
        }
        .add{
            color: #5080cc;
        }

        tr{
            border-bottom: solid;
            border-width: 1px;
            border-color: #d2d2d2;
            padding: 6px;
            width: 370px;
        }

    }
</style>
